import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';
import Truncate from 'react-truncate';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import { DEFAULT_LANGUAGE } from '../../config/constants';

import {
  WysiwygField,
  CoreLink,
} from '..';

import teaser from '../../assets/images/teaser/teaser.png';
import teaserLarge from '../../assets/images/teaser/teaser-large.png';


import './style.scss';


const SimpleTeaser = ({ id, entity, className, imageSrc, withSummary, width }) => {
  const classes = classNames(className, 'ArticleSimpleTeaser mb-6');
  const renderSummary = () => {
    if (!withSummary) {
      return;
    }
    return (
      entity.getIn(['body', 0, 'summary'], '') ? (
        <div className="SimpleTeaser__body">
          <Truncate lines={4} width={width || 0} ellipsis="..." trimWhitespace>
            <WysiwygField
              property="schema:text"
              className="NodeProjectTeaser__body"
              html={entity.getIn(['body', 0, 'summary'], '')}
            />
          </Truncate>
        </div>
      ) : (
        <div className="SimpleTeaser__body">
          <Truncate lines={4} width={width || 0} ellipsis="..." trimWhitespace>
            <WysiwygField
              property="schema:text"
              className="NodeProjectTeaser__body"
              html={entity.getIn(['body', 0, 'processed'], '')}
            />
          </Truncate>
        </div>
      ));
  };

  let fieldImageSrc = {
    0: teaser,
    768: teaserLarge,
  };

  if (entity.getIn(['field_image'], Immutable.List()).size > 0) {
    fieldImageSrc = {
      0: entity.getIn(['field_image', 0, 'styles', 'large']),
      768: entity.getIn(['field_image', 0, 'styles', 'teaser_image']),
    };
  }


  return (
    <article typeof="schema:WebPage" className={classes}>
      <div className="SimpleTeaser teaser">
        <CoreLink to={entity.getIn(['paths', DEFAULT_LANGUAGE])} className="overlapping-link">
          <div>
            <div className="SimpleTeaser__image">
              {
                !imageSrc ? (
                  <Image
                    alt={entity.getIn(['title', 0, 'value'])}
                    src={fieldImageSrc}
                  />
                ) : (
                  <Image
                    alt={entity.getIn(['title', 0, 'value'])}
                    src={imageSrc}
                    includeWebP
                  />
                )
              }
            </div>
            <h3 className="SimpleTeaser__title">{entity.getIn(['title', 0, 'value'])}</h3>
            {renderSummary()}
          </div>
        </CoreLink>
      </div>
    </article>
  );
};

export default SimpleTeaser;
